import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import swal, { SweetAlertResult } from 'sweetalert2';

export enum S1PopUpType {
  Success = "success",
  Warning = "warning",
  Error = "error",
  Info = "info",
  Question = "question"
}

@Injectable({
  providedIn: 'root'
})
export class S1UIService {

  constructor(private translate: TranslateService, private toasterService: ToastrService) { }

  // Spinner
  showSpinner(message?: string) {
    swal.fire({
      title: this.translate.instant('s1.swal.loading'),
      text: message,
      allowEscapeKey: false,
      allowOutsideClick: false,
      imageUrl: 'assets/loader/van.gif',
      imageAlt: 'PTK-loader',
      imageWidth: 100,
      imageHeight: 100,
      showConfirmButton: false
    }).then(_ => {});
  }

  closeSpinner() {
    swal.close();
  }

  // Popup
  showPopup(type: S1PopUpType, title?: string, text?: string) {
    swal.fire(this.translate.instant(title), this.translate.instant(text), type);
  }

  showPopupNoPermission() {
    this.showPopup(S1PopUpType.Warning, 's1.swal.attention',  's1.swal.noPermission')
  }

  showHTTPErrorPopup(error: any) {
    
    let errorTitle = 's1.error'
    let errorMessage = 'genericError'

    if (error.statusText) {
      errorMessage = error.statusText;
    }

    if (error.status) {

      errorTitle = "" + error.status

      switch(error.status) {
        case '0047': 
          errorMessage = this.translate.instant('APIErrors.' + error.status,{range: sessionStorage.getItem('WEB_QUICKBUY_TIMERANGE')})
          break;
        case '0000': //Generic
        case '499': //Unknown error
        case 401: // Unauthorized
        case 403: // Forbidden
          errorMessage = this.translate.instant('APIErrors.' + error.status)
          break;
      }

    }

    this.showPopup(S1PopUpType.Error, errorTitle, errorMessage)

  }

  showDialogPopup(title: string): Promise<SweetAlertResult> {

    return swal.fire({
      title: this.translate.instant('s1.swal.attention'),
      text: this.translate.instant(title),
      icon: S1PopUpType.Question,
      showCloseButton: true,
      showCancelButton: true,
      customClass: {
        cancelButton: 'btn btn-xs btn-danger'
      }
    });

  }

  // TOAST
  showSuccessToast(text: string) {
    this.toasterService.success(this.translate.instant(text), this.translate.instant("s1.toast.success"));
  }

}
